/* =========================================================
   BLACK JAR COLLECTION — Hero scroll cue + story modal
   Loaded from more than one section (hero, modal), so it guards
   against running its setup twice on the same page.

   Story modal: delegated on document so it works no matter how
   many section-bj-family instances (or fragrance blocks) exist.
   Each card's detail content lives in a <template> next to it;
   this script only ever reads it at click time — nothing here
   is hard-coded, so the popup always reflects whatever the
   merchant configured for that specific block.
   ========================================================= */
(function () {
  'use strict';

  if (window.bjLandingJsLoaded) return;
  window.bjLandingJsLoaded = true;

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Hero: scroll cue jumps to the next section down ----
     Shopify wraps every JSON-template section in its own
     .shopify-section div, so the *sections themselves* are never
     siblings — their wrapper divs are. Walk up to that wrapper
     first, or the sibling lookup silently finds nothing. */
  var scrollTriggers = document.querySelectorAll('[data-bj-scroll-next]');
  scrollTriggers.forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var current = trigger.closest('.shopify-section') || trigger.closest('section');
      var next = current ? current.nextElementSibling : null;
      if (!next) return;
      next.scrollIntoView({
        behavior: prefersReducedMotion ? 'auto' : 'smooth',
        block: 'start'
      });
    });
  });

  /* ---- Story modal ---- */
  var backdrop = document.getElementById('bjModalBackdrop');
  if (!backdrop) return;

  var modal = backdrop.querySelector('.bj-modal');
  var closeBtn = document.getElementById('bjModalClose');
  var imageEl = document.getElementById('bjModalImage');
  var familyEl = document.getElementById('bjModalFamily');
  var nameEl = document.getElementById('bjModalName');
  var detailEl = document.getElementById('bjModalDetail');
  var lastFocused = null;

  var FOCUSABLE = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

  function openModal(trigger) {
    var targetId = trigger.getAttribute('data-bj-target');
    var source = targetId ? document.getElementById(targetId) : null;
    if (!source) return;

    familyEl.textContent = source.dataset.family || '';
    nameEl.textContent = source.dataset.name || '';

    // Always clear first, then set — guarantees the element never keeps
    // showing a previous card's image while the new one is being resolved.
    imageEl.removeAttribute('src');
    imageEl.alt = '';
    if (source.dataset.image) {
      imageEl.src = source.dataset.image;
      imageEl.alt = source.dataset.imageAlt || '';
    }

    detailEl.replaceChildren();
    var content = 'content' in source ? source.content : source;
    detailEl.appendChild(content.cloneNode(true));

    lastFocused = trigger;
    backdrop.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    closeBtn.focus();
  }

  function closeModal() {
    backdrop.classList.remove('is-open');
    document.body.style.overflow = '';
    if (lastFocused) {
      lastFocused.focus();
      lastFocused = null;
    }
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-bj-card-trigger]');
    if (trigger) {
      openModal(trigger);
    }
  });

  closeBtn.addEventListener('click', closeModal);

  backdrop.addEventListener('click', function (event) {
    if (event.target === backdrop) closeModal();
  });

  document.addEventListener('keydown', function (event) {
    if (!backdrop.classList.contains('is-open')) return;

    if (event.key === 'Escape') {
      closeModal();
      return;
    }

    if (event.key === 'Tab') {
      var items = modal.querySelectorAll(FOCUSABLE);
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  });
})();
